import AdminRoutes from "./admin";
import CommonRoutes from "./common";

const AllRoutes = [...AdminRoutes, ...CommonRoutes];

export default AllRoutes;
